
import { Close } from '@material-ui/icons';
import axios from 'axios';

import { useState } from 'react';
import  { CallBackProps,Step } from 'react-joyride';

import create from "zustand";

export interface TutorialContextType {
    run: boolean,
    started : boolean,
    setRun: (run: boolean) => void,
    stepIndex: number,
    setStepIndex: (stepIndex: number) => void,
    steps: Step[],
    tourActive: boolean,
    setTourActive: (tourActive: boolean) => void,
    start: ({index:number}) => void,
    pause: () => void,

    handleCallback: (data: CallBackProps) => void,

}

const firstYearTabQuerySelector = "button.year-tab:nth-of-type(1)";
const firstMonthAccordionQuerySelector = ".month-accordion:nth-of-type(1)";
const firstMonthCheckboxQuerySelector = "input.month-checkbox:nth-of-type(1)";
const firstReportPaperQuerySelector = ".report-paper";
const firstReportCheckboxQuerySelector = "input.report-checkbox:nth-of-type(1)";
const firstEntryRichTextEditorCell = '.entry-rich-text-editor-cell';
const firstReportEntryAreaQuerySelector = '.report-entry-area';
const sideBarButtonQuerySelector = ".drawer-button";
const sideBarOverlayQuerySelector = ".drawer-overlay";
const folderSelectQuerySelector = ".folder-select";
const entryListQuerySelector = ".entry-list";
const entrySearchQuerySelector = ".entry-search";
const createEntryButtonQuerySelector = ".create-entry-button";
const multiSelectButtonQuerySelector = ".multi-select-button";
const entryAccordionQuerySelector = ".entry-accordion";
const entryAccordionCheckboxQuerySelector = "input.entry-checkbox:nth-of-type(1)";
const entryAccordionCompleteEntryButtonQuerySelector = ".entry-accordion .complete-entry-button";
const entryAccordionDeleteEntryButtonQuerySelector = ".entry-accordion .delete-entry-button";
const entryAccordionReportSectionSelectQuerySelector = ".entry-accordion .report-section-select";
const entryAccordionRichTextEditorQuerySelector = ".entry-accordion .rich-text-editor-container";
const entryAccordionEntryNameQuerySelector = ".entry-accordion input[name='name']";
const entryAccordionDurationInputQuerySelector = ".entry-accordion input[name='maxHours']";
const downloadEntriesButtonQuerySelector = ".download-entries-button";
const randomizeEntriesButtonQuerySelector = ".randomize-entries-button";
const calendarEntriesButtonQuerySelector = ".import-ical-entries-button";
const exportReportsButtonQuerySelector = ".export-reports-button";
const startTutorialButtonQuerySelector = ".start-tutorial-button";

function openFirstReportAccordion() {
    const reportCheckbox = document.querySelector<HTMLInputElement>(firstReportCheckboxQuerySelector)
    if (reportCheckbox !== null && reportCheckbox.checked == false) {
        reportCheckbox.click();
    }
}

function elementExists(selector: string) {
    return document.querySelector(selector) !== null;
}

function firstMonthAccordionCheckboxExists() {
    return elementExists(firstMonthCheckboxQuerySelector);
}
function durationInputExists(){
    return elementExists(entryAccordionDurationInputQuerySelector);
}


function openFirstMonthAccordion() {
    const monthEl = document.querySelector<HTMLInputElement>(firstMonthCheckboxQuerySelector);
    if (monthEl !== null && monthEl.checked == false) {
        monthEl.click();
    }
}
function openFirstEntryAccordion(){
    const entryAccordion = document.querySelector<HTMLInputElement>(entryAccordionCheckboxQuerySelector);
    if (entryAccordion !== null && entryAccordion.checked == false) {
        entryAccordion.click();
    }
}
function openSideBar() {
    const sideBarButton = document.querySelector<HTMLLabelElement>(sideBarButtonQuerySelector);
    if (sideBarButton !== null) {
        sideBarButton.click();
    }
}
function closeSideBar() {
    //console.log("trying to close sidebar");
    const sideBarButton = document.querySelector<HTMLLabelElement>(sideBarOverlayQuerySelector);
    if (sideBarButton !== null) {
        sideBarButton.click();
    }
}

function entryCountInFirstReportEntryArea(): number{
    const entryArea = document.querySelector<HTMLDivElement>(firstReportEntryAreaQuerySelector);
    if (entryArea !== null) {
        return entryArea.childElementCount;
    }
    return 0;
}





export const useTutorial = create<TutorialContextType>((set) => ({

    run: false,
    stepIndex: 0,
    steps: [

        //index 0 - year tab
        {
            disableBeacon: true,
            title: "Willkommen zum Berichtsheft Generator",
            content: 'Deine Berichte wurden erstellt und in Ausbildungsjahre sortiert.',
            placement: 'bottom',
            target: firstYearTabQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),
            disableOverlayClose: true,
            spotlightClicks: true,

        },
        //index 1 - month accordion
        {
            disableBeacon: true,
            title: "Berichte ansehen",
            content: 'Berichte werden in Monate unterteilt.',
            placement: 'bottom',
            target: firstMonthAccordionQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 2 - report accordion
        {
            disableBeacon: true,
            title: "Bericht bearbeiten",
            content: 'Hier ist eines deiner Berichte.',
            placement: 'center',
            target: firstReportPaperQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 3 - report rich text editor
        {
            disableBeacon: true,
            title: "Aufgaben eintragen",
            content: (<><span>{" Du kannst deine Aufgaben direkt in deine Vorlage eintippen. Wenn du mit dem Text zufrieden bist, klicke einfach weg, um die Aufgabe zu speichern."}</span><br /><span><strong>{"Probiere es aus! Erstelle zwei Aufgaben."}</strong></span></>),
            placement: 'top',
            target: firstEntryRichTextEditorCell,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            disableScrolling: true,
            tooltipComponent:(props)=>(<Tooltip {...props}/>),
            disableOverlayClose: true,
            spotlightClicks: true,
        },
        //index 4 - entry area
        {
            disableBeacon: true,
            title: "Aufgaben eintragen und sortieren",
            content: 'Im Anschluß erscheinen die Aufgaben hier und werden einem Aufgabenordner zugeordnet. Um die Reihenfolge der Aufgaben zu ändern, kannst du eine Aufgabe anklicken und in eine neue Position ziehen.',
            placement: 'bottom',
            target: firstReportEntryAreaQuerySelector,
            spotlightPadding: 7,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            
            tooltipComponent:(props)=>(<Tooltip {...props}/>),
            disableScrolling: true,
            disableOverlayClose: true,
            spotlightClicks: true,
        },
        //index 5 - folder select
        {
            disableBeacon: true,
            title: "Aufgabenordner",
            content: 'Hier sind deine Aufgabenordner. ',
            placement: 'bottom',
            target: folderSelectQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 6
        {
            disableBeacon: true,
            title: "Aufgabenliste",
            content: 'Hier sind alle Aufgaben die dem ausgewählten Aufgabenordner zugeordnet sind.',
            placement: 'bottom',
            target: entryListQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 7
        {
            disableBeacon: true,
            title: "Aufgaben filtern",
            content: 'Um eine Aufgabe schneller, in dem ausgewählten Aufgabenordner zu finden, kannst du hier einen Suchbegriff eintippen.',
            placement: 'bottom',
            target: entrySearchQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 8
        {
            disableBeacon: true,
            title: "Aufgaben erstellen",
            content: 'Hier kannst du eine neue Aufgabe erstellen.',
            placement: 'bottom',
            target: createEntryButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 9
        {
            disableBeacon: true,
            title: "Mehrauswahl",
            content: 'Hier kannst du eine oder mehrere Aufgaben auswählen und einige Funktionen, mit dieser Auswahl, ausführen.',
            placement: 'bottom',
            target: multiSelectButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 10
        {
            disableBeacon: true,
            title: "Aufgabendetails bearbeiten",
            content: 'Hier kannst du verschiedene Details einer Aufgabe bearbeiten.',
            placement: 'bottom',
            target: entryAccordionQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 11
        {
            disableBeacon: true,
            title: "Aufgabe ins Berichtsehft eintragen",
            content: 'Hier kannst du die Daten auswählen an denen die Aufgabe erledigt wurde.',
            placement: 'bottom',
            target: entryAccordionCompleteEntryButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 12
        {
            disableBeacon: true,
            title: "Aufgabe löschen",
            content: 'Hier kannst du die Aufgabe löschen. Somit wird sie auch aus allen Berichten entfernt.',
            placement: 'bottom',
            target: entryAccordionDeleteEntryButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 13
        {
            disableBeacon: true,
            title: "Vorlagenbereiche",
            content: 'Aufgaben müssen einem Vorlagenbereich zugeordnet werden, damit der Berichtsheft Generator weiß, in welcher Tabellenzelle der Vorlage die Aufgabe dargestellt werden soll.',
            placement: 'bottom',
            target: entryAccordionReportSectionSelectQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),
        
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 14
        {
            disableBeacon: true,
            title: "Aufgabenbeschreibung bearbeiten",
            content: 'Hier kannst du die Beschreibung einer Aufgabe bearbeiten. Wenn du die Beschreibung hier änderst, wird sie auch in allen Berichten aktualisiert.',
            placement: 'bottom',
            target: entryAccordionRichTextEditorQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 15
        {
            disableBeacon: true,
            title: "Aufgabenname bearbeiten",
            content: 'Hier kannst du den Namen einer Aufgabe bearbeiten. Der Name dient nur zur besseren Übersicht in der Aufgabenliste.',
            placement: 'bottom',
            target: entryAccordionEntryNameQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 16
        {
            disableBeacon: true,
            title: "Aufgabendauer bzw. Stunden bearbeiten",
            content: 'Hier kannst du die Dauer der Aufgabe, in Stunden, angeben. Dieser Wert wird für die Berechnung der Stunden bzw. Gesamtstunden verwendet.',
            placement: 'bottom',
            target: entryAccordionDurationInputQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 17
        {
            disableBeacon: true,
            title: "Aufgaben herunterladen",
            content: 'Hier kannst du Aufgaben herunterladen.',
            placement: 'bottom',
            target: downloadEntriesButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 18
        {
            disableBeacon: true,
            title: "Aufgaben verteilen",
            content: 'Hier kannst du Aufgaben verteilen lassen.',
            placement: 'bottom',
            target: randomizeEntriesButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 19
        {
            disableBeacon: true,
            title: "Kalender importieren",
            content: 'Hier kannst du Einträge, wie z.B. Krank- oder Urlaubstage, aus deinem Firmen- bzw. Privatkalender importieren.',
            placement: 'top',
            target: calendarEntriesButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props}/>),

            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 20
        {
            disableBeacon: true,
            title: "Berichte exportieren",
            content: 'Hier kannst du deine Berichte exportieren.',
            placement: 'top',
            target: exportReportsButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props} isLast={true}/>),
            
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        //index 21
        {
            disableBeacon: true,
            title: "Tutorial starten",
            content: 'Hier kannst du das Tutorial nochmal starten, falls du vergisst, wie man den Berichtsheft Generator benutzt.',
            placement: 'top',
            target: startTutorialButtonQuerySelector,
            spotlightPadding: 0,
            styles: {
                options: {
                    zIndex: 10000,
                },
            },
            tooltipComponent:(props)=>(<Tooltip {...props} isLast={true}/>),
            
            disableOverlayClose: true,
            spotlightClicks: false,
        },
       
    ],
    tourActive: false,
    started: false,
    setStepIndex: (stepIndex: number) => set((state) => ({ ...state, stepIndex })),
    setSteps: (steps: Step[]) => set((state) => ({ ...state, steps })),
    setTourActive: (tourActive: boolean) => set((state) => ({ ...state, tourActive })),
    setRun: (run: boolean) => set((state) => ({ ...state, run })),
    start: ({index = 0}) => {
        set((state) => ({ ...state, started: true,index:index }));
        localStorage.setItem('finishedTutorial', 'false');
        return set((state) => ({ ...state, run: true, tourActive: true }));
    },
    pause: () => set((state) => ({ ...state, run: false })),
    
    handleCallback: (data: CallBackProps) => {
        
        
        const { action, index, lifecycle, status, type } = data;
        //console.log("callback called....",type);
        const isLastStep = index == data.size;
        
        console.log("callback called currently on step ....",index);

        if(status == "finished"){
            onFinished()
        }

        if(action == 'close' || isLastStep) {

           onFinished()

        }else if (type == 'step:after' && index == 0 /* or step.target == '#home' */) {
            //setState({ run: false });

          

            if (firstMonthAccordionCheckboxExists()) {

                handlePrevAndNext(index, action, openFirstMonthAccordion(), null);

            } else {
               //click report accordion instead because month is missing, probably monatliche berichte
                //skip step
                if(action == 'next'){
                    openFirstReportAccordion();
                }
                waitForElement(firstReportPaperQuerySelector,500,()=>handlePrevAndNext(index + 1, action))

            }



        } else if (type == 'step:after' && index == 1) {


            //setState({ run: false });
        
            if(action == 'next'){
                openFirstReportAccordion();
                waitForElement(firstReportPaperQuerySelector,500,()=>handlePrevAndNext(index, action))
            }else{
                handlePrevAndNext(index, action)
            }

        }
        else if (type == 'step:after' && index == 2) {
                handlePrevAndNext(index, action);
        }
        else if (type == 'step:after' && index == 3) {

          
                handlePrevAndNext(index, action);
            


        } else if (type == 'step:after' && index == 4) {

         
            
                 openSideBar();
                setTimeout(() => {
                    handlePrevAndNext(index, action);
                }, 500);
            

           
        } else if (type == 'step:after' && index == 5) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 6) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 7) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 8) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 9) {
    
            const exists = elementExists(entryAccordionCheckboxQuerySelector)

            const indexToNavigateTo = exists ? index : 16; //one will be added in handleprevandnext so index = 17
            //if we dont skip ahead tutorial will fail because user didnt create any entries! in this case skip important functions but allow user to finish tutorial.
            if(exists){
                openFirstEntryAccordion();

            setTimeout(() => {
                handlePrevAndNext(indexToNavigateTo, action);
            }, 500);
        }else{
            handlePrevAndNext(indexToNavigateTo, action);
        }
            
        } else if (type == 'step:after' && index == 10) {

           

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 11) {

       
            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 12) {

            handlePrevAndNext(index, action);

        } else if (type == 'step:after' && index == 13) {

       
            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 14) {

       
            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 15) {

            if(durationInputExists()){
                handlePrevAndNext(index, action);
            }else{
                //skip one step so it doesnt fail, probably the template doesnt have maxHours
                // closeSideBar();
                // setTimeout(() => {
                //     handlePrevAndNext(index + 1, action);
                // }, 500);
                handlePrevAndNext(index + 1, action);
            }

        } else if (type == 'step:after' && index == 16) {
            
            handlePrevAndNext(index, action);
            
        } else if (type == 'step:after' && index == 17) {
            
          
            handlePrevAndNext(index, action);

            
        } else if (type == 'step:after' && index == 18) {

            handlePrevAndNext(index, action);

           
        } else if (type == 'step:after' && index == 19) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 20) {

            closeSideBar();
            setTimeout(() => {
                handlePrevAndNext(index, action);
            }, 500);
            
        } else if (type == 'step:after' && index == 21) {

            handlePrevAndNext(index, action);
        } else if (type == 'step:after' && index == 22) {

       
            handlePrevAndNext(index, action);
        } else if (action == 'reset' || lifecycle == 'complete') {
            //setState({ run: false, stepIndex: 0, tourActive: false });
            set((state) => ({ ...state, run: false, stepIndex: 0, tourActive: false, started:false  }));
        }

    

        function waitForElement(selector: string,ms : number = 500, callback: () => void) {
            if (document.querySelector(selector)) {
                callback();
            } else {
                setTimeout(() => {
                    waitForElement(selector,ms, callback);
                }, ms);
            }
        }
       
        function onFinished(){
            localStorage.setItem('finishedTutorial', 'true');
            setCompletedTutorial();
            set((state) => ({ ...state, run: false, tourActive: false, stepIndex: 0, started: false }))
        }
        function setCompletedTutorial(){
             //const baseUrl = "https://berichtsheft-generator.app:443"
             const baseUrl = process.env.NODE_ENV == "production" ? "https://berichtsheft-generator.app:443" : "http://alens-mac-mini.local:8181";
            axios.post(`${baseUrl}/protected/setCompletedTutorial`,null, {
                headers: {
                    'authorization': `Bearer ${localStorage.getItem("accessToken")}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
        }
        function handlePrevAndNext(index, action, performBeforeNext = null, performBeforePrev = null) {
            if (action == 'next') {
                //setState({ run: false });
                performBeforeNext && performBeforeNext();
                set((state) => ({ ...state, stepIndex: index + 1 }))
            } else {
                //setState({ run: true, stepIndex: 0 });
                var decrementBy = 1;
                
                switch (index) {
                   
                    case 17: decrementBy = elementExists(entryAccordionCheckboxQuerySelector) ? 1 : 8; break;
                   
                    case 2: decrementBy = firstMonthAccordionCheckboxExists() ? 1 : 2; break;
                    default: decrementBy = 1;
                }
                
                performBeforePrev && performBeforePrev();
                set((state) => ({ ...state, run: true, stepIndex: index - decrementBy }));

            }
        }

        

    }



}));


const Tooltip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    isLast = false

  }) => {

    
        const [nextButtonEnabled, setNextButtonEnabled] = useState((index == 3 && entryCountInFirstReportEntryArea()>=4)||(index !== 3));
    
            if(!nextButtonEnabled && index == 3){
                waitForCondition(()=>entryCountInFirstReportEntryArea()>=4,500,()=>setNextButtonEnabled(true))
            }
            
        

        return (
            <div className='bg-white max-w-sm text-base-300 p-4 space-y-4 rounded-lg relative' {...tooltipProps}>
                <div className='absolute top-2 right-2'>{continuous && (
                    <button {...closeProps} className={`btn btn-square btn-xs`}>
                        <Close className='p-1' />
                    </button>
                )}</div>
                {step.title && <h1 className='text-lg font-bold text-center'>{step.title}</h1>}
                <p>{step.content}</p>
                <div className='flex flex-row justify-end space-x-4'>
                    {index > 0 && (
                        <button {...backProps} className={`btn btn-sm`}>
                            Zurück
                        </button>
                    )}
                    {continuous && (
                        <button {...primaryProps} className={`btn btn-sm btn-primary ${!nextButtonEnabled && "text-base-300 btn-disabled"}`}>
                            {isLast ? 'Fertig' : 'Weiter'}
                        </button>
                    )}

                </div>
            </div>
        );
        function waitForCondition(conditionToCheck:()=> boolean,ms : number = 500, callback: () => void) {
            if (conditionToCheck()) {
                callback();
            } else {
                setTimeout(() => {
                    waitForCondition(conditionToCheck,ms, callback);
                }, ms);
            }
        }
    }